if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const setWiseQuantity = this.form.querySelector('[name="quantity"][data-set-wise="true"]');
        if (setWiseQuantity) {
          const currentQty = Math.max(0, parseInt(setWiseQuantity.value, 10) || 0);
          const setQty = Math.max(1, parseInt(setWiseQuantity.dataset.setQty, 10) || parseInt(setWiseQuantity.dataset.setQuantity, 10) || parseInt(setWiseQuantity.step, 10) || 1);
          const remainder = currentQty % setQty;
          formData.set('quantity', String(remainder ? setQty - remainder : setQty));
        }
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (!this.cart) {
              if (typeof window.refreshProductCardCartQuantities === 'function') window.refreshProductCardCartQuantities();
              return;
            }
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(function () {
  if (window.productCardCartSyncInitialized) {
    window.refreshProductCardCartQuantities?.();
    return;
  }
  window.productCardCartSyncInitialized = true;

  let refreshRequest = null;
  let refreshTimer = null;
  let currentCart = { items: [] };
  let quantityChangePending = false;

  function stepperMarkup(quantity) {
    return `<span class="card-cart-stepper"><span class="card-cart-stepper__control" data-card-cart-decrease aria-hidden="true">−</span><span class="card-cart-stepper__quantity">${quantity}</span><span class="card-cart-stepper__control" data-card-cart-increase aria-hidden="true">+</span></span>`;
  }

  function escapeCartLabel(value) {
    const element = document.createElement('span');
    element.textContent = String(value || '');
    return element.innerHTML;
  }

  function readymadeCartMarkup(items) {
    const sizes = new Map();
    let totalQuantity = 0;

    (items || []).forEach((item) => {
      if (!item.quantity) return;
      const quantity = Number(item.quantity || 0);
      totalQuantity += quantity;
      const optionSize = (item.options_with_values || []).find((option) =>
        String(option.name || '').toLowerCase().includes('size')
      )?.value;
      const rawSize = optionSize || (item.variant_title !== 'Default Title' ? item.variant_title : 'Selected');
      const size = String(rawSize).trim();
      sizes.set(size, (sizes.get(size) || 0) + quantity);
    });

    const sizeRank = (size) => {
      const normalized = String(size).toUpperCase().replace(/\s+/g, '');
      const ranks = { XS: 10, S: 20, M: 30, L: 40, XL: 50, XXL: 60, '2XL': 60, XXXL: 70, '3XL': 70, '4XL': 80, '5XL': 90 };
      return ranks[normalized] || 999;
    };

    const entries = Array.from(sizes.entries()).sort((a, b) =>
      sizeRank(a[0]) - sizeRank(b[0]) || String(a[0]).localeCompare(String(b[0]))
    );
    const breakdown = entries
      .map(([size, quantity]) => `<span class="readymade-cart-size">${escapeCartLabel(size)}: ${quantity}</span>`)
      .join('<span class="readymade-cart-divider">•</span>');

    return `<span class="readymade-cart-summary"><span class="readymade-cart-summary__primary">✓ Added — ${totalQuantity} Pcs</span><span class="readymade-cart-summary__breakdown">${breakdown}</span></span><span class="readymade-cart-manage-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M4 7h10M18 7h2M4 17h2M10 17h10M4 12h4M12 12h8"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/><circle cx="10" cy="12" r="2"/></svg></span>`;
  }

  function updateIndicators(cart) {
    currentCart = cart;
    const quantities = new Map();
    const itemsByProduct = new Map();
    (cart.items || []).forEach((item) => {
      const productId = String(item.product_id);
      quantities.set(productId, (quantities.get(productId) || 0) + item.quantity);
      if (!itemsByProduct.has(productId)) itemsByProduct.set(productId, []);
      itemsByProduct.get(productId).push(item);
    });

    document.querySelectorAll('[data-cart-product-action][data-product-id]').forEach((button) => {
      if (button.disabled) return;
      const label = button.querySelector('[data-cart-product-action-label]');
      if (!label) return;
      if (!button.dataset.defaultCartLabel) button.dataset.defaultCartLabel = label.textContent.trim();
      const quantity = quantities.get(String(button.dataset.productId)) || 0;
      button.dataset.cartProductQuantity = String(quantity);
      button.setAttribute('aria-label', quantity > 0 ? `${quantity} Pcs in cart` : button.dataset.defaultCartLabel);
      if (quantity > 0) {
        if (button.dataset.cartReadymade === 'true') {
          label.innerHTML = readymadeCartMarkup(itemsByProduct.get(String(button.dataset.productId)) || []);
          button.classList.add('readymade-cart-state');
        } else {
          label.innerHTML = stepperMarkup(quantity);
          button.classList.remove('readymade-cart-state');
        }
      } else {
        label.textContent = button.dataset.defaultCartLabel;
        button.classList.remove('readymade-cart-state');
      }
    });
  }

  async function refreshProductCardCartQuantities() {
    if (!document.querySelector('[data-cart-product-action][data-product-id]')) return;
    if (refreshRequest) return refreshRequest;

    const root = window.Shopify?.routes?.root || '/';
    refreshRequest = fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(updateIndicators)
      .catch((error) => console.error('[Product card cart quantity]', error))
      .finally(() => {
        refreshRequest = null;
      });

    return refreshRequest;
  }

  async function removeOneSet(button) {
    if (quantityChangePending) return;
    const productId = String(button.dataset.productId);
    const variantId = Number(button.dataset.cartVariantId);
    const setQuantity = Math.max(1, Number(button.dataset.cartSetQuantity) || 1);
    const lineItem = (currentCart.items || []).find(
      (item) => String(item.product_id) === productId && Number(item.variant_id) === variantId
    );
    if (!lineItem) {
      await refreshProductCardCartQuantities();
      return;
    }

    quantityChangePending = true;
    button.setAttribute('aria-disabled', 'true');
    const root = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: Math.max(0, lineItem.quantity - setQuantity),
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      if (!response.ok) throw new Error('Unable to update cart');
      const cart = await response.json();
      updateIndicators(cart);

      if (cart.sections?.['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
        const incoming = parsed.getElementById('shopify-section-cart-icon-bubble');
        const current = document.getElementById('shopify-section-cart-icon-bubble');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-card-stepper',
          productVariantId: String(variantId),
          cartData: cart,
        });
      }
    } catch (error) {
      console.error('[Product card cart quantity]', error);
      await refreshProductCardCartQuantities();
    } finally {
      quantityChangePending = false;
      button.removeAttribute('aria-disabled');
    }
  }

  async function addOneSet(button) {
    if (quantityChangePending) return;
    const productId = String(button.dataset.productId);
    const variantId = Number(button.dataset.cartVariantId);
    const setQuantity = Math.max(1, Number(button.dataset.cartSetQuantity) || 1);
    let lineItem = (currentCart.items || []).find(
      (item) => String(item.product_id) === productId && Number(item.variant_id) === variantId
    );

    if (!lineItem) {
      await refreshProductCardCartQuantities();
      lineItem = (currentCart.items || []).find(
        (item) => String(item.product_id) === productId && Number(item.variant_id) === variantId
      );
    }
    if (!lineItem) return;

    quantityChangePending = true;
    button.setAttribute('aria-disabled', 'true');
    const root = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: lineItem.quantity + setQuantity,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      if (!response.ok) throw new Error('Unable to update cart');
      const cart = await response.json();
      updateIndicators(cart);

      if (cart.sections?.['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
        const incoming = parsed.getElementById('shopify-section-cart-icon-bubble');
        const current = document.getElementById('shopify-section-cart-icon-bubble');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-card-stepper',
          productVariantId: String(variantId),
          cartData: cart,
        });
      }
    } catch (error) {
      console.error('[Product card cart quantity]', error);
      await refreshProductCardCartQuantities();
    } finally {
      quantityChangePending = false;
      button.removeAttribute('aria-disabled');
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshProductCardCartQuantities, 0);
  }

  function controlWasClicked(event, control) {
    if (!control) return false;
    if (event.target.closest?.('[data-card-cart-decrease], [data-card-cart-increase]') === control) return true;
    if (typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return false;
    const rect = control.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-cart-product-action][data-product-id]');
      if (!button || Number(button.dataset.cartProductQuantity || 0) < 1) return;

      if (button.dataset.cartMultiVariant === 'true') {
        if (button.dataset.cartReadymade === 'true' && button.dataset.cartManageUrl) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign(button.dataset.cartManageUrl);
        }
        return;
      }

      const decreaseControl = button.querySelector('[data-card-cart-decrease]');
      const increaseControl = button.querySelector('[data-card-cart-increase]');

      if (controlWasClicked(event, decreaseControl)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        removeOneSet(button);
        return;
      }

      if (controlWasClicked(event, increaseControl)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addOneSet(button);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  window.refreshProductCardCartQuantities = refreshProductCardCartQuantities;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }

  window.addEventListener('pageshow', scheduleRefresh);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  }

  new MutationObserver((mutations) => {
    const hasNewProductCard = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === 1 &&
        (node.matches?.('[data-cart-product-action]') || node.querySelector?.('[data-cart-product-action]'))
      )
    );
    if (hasNewProductCard) scheduleRefresh();
  }).observe(document.body, { childList: true, subtree: true });
})();
